module.exports = __webpack_public_path__ + "img/bz28@2x.baa24889.png";